module.exports = __webpack_public_path__ + "static/media/facebook.a895b64d.svg";